<template>
  <div>
    <div class="fl-cabecalho">
      <div class="row animated slideInDown">
        <div class="col-12 form-group">
          <h4 class="animated slideInDown">
            <fa-icon icon="ticket-alt" />Tickets
            <fa-icon icon="angle-right" />
            {{ form.codigo }}
            <button @click="$emit('fechar')" class="btn btn-sm btn-outline-primary float-right">
              <fa-icon icon="arrow-left" />
              <span v-if="!_isMobile">Voltar</span>
            </button>
          </h4>
        </div>
      </div>
    </div>
    <hr />

    <div class="row">
      <div class="col-12 text-center">
        <h4 style="margin-bottom: 0px">{{ form.titulo }}</h4>
        <p style="color: #777; margin-bottom: 0">TÍTULO</p>
      </div>
    </div>

    <hr />

    <div class="row text-center">
      <div class="col-md-4">
        <h5 style="margin-bottom: 0px">{{ form.nomeCliente }}</h5>
        <p style="color: #777">CLIENTE</p>
      </div>
      <div class="col-md-4">
        <h5 style="margin-bottom: 0px">{{ form._dataAbertura }}</h5>
        <p style="color: #777">ABERTURA</p>
      </div>
      <div class="col-md-4">
        <h5 style="margin-bottom: 0px" :class="{
          'text-danger': form.status == 'C',
          'text-success': form.status == 'O',
          'text-primary': form.status == 'A',
          'text-info': form.status == 'E',
        }">
          <span v-if="form.status == 'A'">ABERTO</span>
          <span v-if="form.status == 'C'">CANCELADO</span>
          <span v-if="form.status == 'O'">CONCLUÍDO</span>
          <span v-if="form.status == 'E'">EM ANDAMENTO</span>
        </h5>
        <p style="color: #777">
          <small>{{
            form.status != "O" ? "STATUS" : form._dataEncerramento
          }}</small>
        </p>
      </div>
    </div>

    <div class="row text-center">
      <div class="col-md-4">
        <h5 style="margin-bottom: 0px">{{ form.nomeUsuario }}</h5>
        <p style="color: #777">USUÁRIO</p>
      </div>
      <div class="col-md-4">
        <h5 style="margin-bottom: 0px">{{ form.loginUsuario }}</h5>
        <p style="color: #777">LOGIN</p>
      </div>
      <div class="col-md-4">
        <h5 style="margin-bottom: 0px">{{ form.emailUsuario }}</h5>
        <p style="color: #777">E-MAIL</p>
      </div>
    </div>

    <hr />

    <div class="row text-center">
      <div class="col-md-4" v-if="form.prioridade">
        <h5 style="margin-bottom: 0px">{{ form.prioridade }}</h5>
        <p style="color: #777">PRIORIDADE</p>
      </div>

      <div class="col-md-4" v-if="form._dataPrevisao">
        <h5 style="margin-bottom: 0px">{{ form._dataPrevisao }}</h5>
        <p style="color: #777">PREVISÃO</p>
      </div>
      <div class="col-md-4" v-if="form.nomeResponsavel">
        <h5 style="margin-bottom: 0px">
          {{ form.nomeResponsavel.toUpperCase() }}
        </h5>
        <p style="color: #777">RESPONSÁVEL</p>
      </div>
    </div>

    <form v-if="form.status != 'O' && form.status != 'C' && _getPrivilegio(28)" style="margin-top: 20px"
      @submit.prevent="validateBeforeSubmit">
      <div class="form-group row" v-if="!form.id">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">* Titulo:</label>
        <div class="col-sm-6">
          <input v-model="form.titulo" class="form-control form-control-sm" v-validate="'required'" name="titulo"
            :class="{ 'is-invalid': errors.has('titulo') }" />
        </div>
      </div>
      <div class="form-group row">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Data
          Previsão:</label>
        <div class="col-sm-6">
          <input v-model="form.dataPrevisao" class="form-control form-control-sm" v-validate="''" style="display: none"
            name="Previsão" :class="{ 'is-invalid': errors.has('Previsão') }" />
          <date-picker ref="date" :disabled="!_getPrivilegio(36)" :clearable="false" :input-class="
            'form-control form-control-sm ' +
            (errors.has('Previsão') ? 'is-invalid' : '')
          " v-model="form.dataPrevisao" format="DD/MM/YYYY HH:mm" type="datetime" :minute-step="1" :not-before="agora"
            :confirm="true" lang="pt-br"></date-picker>
          <span class="invalid-feedback" v-show="errors.has('Previsão')">{{
            errors.first("Previsão")
          }}</span>
          <small class="text-info">
            <fa-icon icon="info-circle" />O status muda pra "EM ANDAMENTO" após
            salvar uma previsão.
          </small>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail"
          class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Classificação:</label>
        <div class="col-sm-6">
          <input v-model="form.classificacao" class="form-control form-control-sm" v-validate="''" name="Classificação"
            :class="{ 'is-invalid': errors.has('Classificação') }" />
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Tipo de
          Ticket:</label>
        <div class="col-sm-6">
          <select v-model="form.tipoTicket" name="Tipo do Ticket" v-validate="''" :disabled="!_getPrivilegio(36)"
            :class="{ 'is-invalid': errors.has('Tipo fo Ticket') }" class="form-control form-control-sm">
            <option value="0" disabled selected>
              Selecione um Tipo de Ticket
            </option>
            <option v-for="item in tiposTicket" :value="item.nome" :key="item.id">
              {{ item.nome }}
            </option>
          </select>
          <span class="invalid-feedback" v-show="errors.has('Tipo de Ticket')">{{ errors.first("Tipo de Ticket") }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Projeto:</label>
        <div class="col-sm-6">
          <select v-model="form.idProjeto" name="Projeto" v-validate="''" :disabled="!_getPrivilegio(36)"
            :class="{ 'is-invalid': errors.has('Projeto') }" class="form-control form-control-sm">
            <option value="0" disabled selected>Selecione um Projeto</option>
            <option v-for="item in projetos" :value="item.id" :key="item.id">
              {{ item.nome }}
            </option>
          </select>
          <span class="invalid-feedback" v-show="errors.has('Projeto')">{{
            errors.first("Projeto")
          }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Módulo:</label>
        <div class="col-sm-6">
          <select v-model="form.modulo" name="Modulo" v-validate="''" :disabled="!_getPrivilegio(36)"
            :class="{ 'is-invalid': errors.has('Modulo') }" class="form-control form-control-sm">
            <option value="0" disabled selected>Selecione um Módulo</option>
            <option v-for="item in modulos" :value="item.descricao" :key="item.descricao">
              {{ item.descricao }}
            </option>
          </select>
          <span class="invalid-feedback" v-show="errors.has('Modulo')">{{
            errors.first("Modulo")
          }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail"
          class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Responsável:</label>
        <div class="col-sm-6">
          <select v-model="form.idUsuarioResponsavel" name="Responsável" v-validate="''" :disabled="!_getPrivilegio(36)"
            :class="{ 'is-invalid': errors.has('Responsável') }" class="form-control form-control-sm">
            <option value="0" disabled selected>
              Selecione um responsavável
            </option>
            <option v-for="item in __usuariosLista" :value="item.id" :key="item.id">
              {{ item.nome }}
            </option>
          </select>
          <span class="invalid-feedback" v-show="errors.has('Responsável')">{{
            errors.first("Responsável")
          }}</span>
        </div>
      </div>

      <div class="form-group row" v-if="form.status == 'E' && _getPrivilegio(28)">
        <label for="inputPassword" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm"></label>
        <div class="col-sm-6">
          <button type="button" @click="clickDesenvolvimentoConcluido()" class="btn btn-sm btn-block float-right" :class="{
            'btn-outline-secondary': !form.desenvolvimentoConcluido,
            'btn-secondary': form.desenvolvimentoConcluido,
          }">
            <span v-if="!form.desenvolvimentoConcluido">
              <fa-icon :icon="['far', 'circle']" />CONCLUIR DESENVOLVIMENTO
            </span>
            <span v-if="form.desenvolvimentoConcluido">
              <fa-icon icon="check-circle" />DESENVOLVIMENTO CONCLUÍDO
            </span>
          </button>
        </div>
      </div>

      <div class="form-group row">
        <label for="inputPassword"
          class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Prioridade:</label>
        <div class="col-sm-6">
          <select v-model="form.prioridade" :disabled="!_getPrivilegio(36)" name="Prioridade" v-validate="''"
            :class="{ 'is-invalid': errors.has('Prioridade') }" class="form-control form-control-sm">
            <option value disabled selected>Selecione uma prioridade</option>
            <option value="BAIXA">BAIXA</option>
            <option value="MÉDIA">MÉDIA</option>
            <option value="ALTA">ALTA</option>
            <!-- <option value="ALTÍSSIMA">ALTÍSSIMA</option> -->
            <!-- <option value="INDEPENDENCE DAY">INDEPENDENCE DAY</option> -->
          </select>
          <span class="invalid-feedback" v-show="errors.has('Prioridade')">{{
            errors.first("Prioridade")
          }}</span>
        </div>
      </div>

      <div class="form-group row" v-if="!form.id">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">* Cliente:</label>
        <div class="col-sm-6">
          <select v-model="form.idCliente" name="cliente" v-validate="'required'" :disabled="!_getPrivilegio(36)"
            :class="{ 'is-invalid': errors.has('cliente') }" class="form-control form-control-sm">
            <option value="0" disabled selected>Selecione um cliente</option>
            <option v-for="item in listaClientes" :value="item.id" :key="item.id">
              {{ item.nome }}
            </option>
          </select>
          <span class="invalid-feedback" v-show="errors.has('cliente')">{{
            errors.first("cliente")
          }}</span>
        </div>
      </div>

      <div class="form-group row">
        <label for="staticEmail" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">Ticket visivel
          para cliente:</label>
        <div class="col-sm-6">
          <div class="radio">
            <label class="radio-inline">
              <input id="visivelCliente" type="radio" v-model="form.visivelCliente" :value="true" />
              Sim </label>&nbsp;&nbsp;&nbsp;
            <label class="radio-inline">
              <input id="visivelCliente" type="radio" v-model="form.visivelCliente" :value="false" />
              Não
            </label>
          </div>

          <span class="invalid-feedback" v-show="errors.has('cliente')">{{
            errors.first("cliente")
          }}</span>
        </div>
      </div>

      <div class="form-group row" v-if="!form.id">
        <label for="descricao" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm">* Descrição:</label>
        <div class="col-sm-6">
          <div class="trix-box">
            <vue-editor v-validate="'required'" :editorToolbar="customToolbar" v-model="form.descricao"></vue-editor>
          </div>
          <span class="invalid-feedback" v-show="errors.has('descricao')">{{
            errors.first("descricao")
          }}</span>
        </div>
      </div>

      <div v-if="
        form.status == 'E' &&
        _getPrivilegio(28) &&
        !form.cancelar &&
        form.desenvolvimentoConcluido
      " class="form-group row">
        <label for="inputPassword" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm"></label>
        <div class="col-sm-6">
          <button @click="form.concluir = !form.concluir" type="button" class="btn btn-sm btn-block float-right" :class="{
            'btn-outline-success': !form.concluir,
            'btn-success': form.concluir,
          }">
            <fa-icon :icon="['far', 'circle']" v-show="!form.concluir" />
            <fa-icon icon="check-circle" v-show="form.concluir" />CONCLUIR
            TICKET
          </button>

          <div v-if="form.concluir" style="margin-top: 3em">
            <div class="trix-box">
              <vue-editor :editorToolbar="customToolbarConcluir" v-model="textoConclussao"></vue-editor>
            </div>
          </div>
        </div>
      </div>

      <div v-if="_getPrivilegio(28) && form.id" class="form-group row">
        <label for="inputPassword" class="offset-sm-1 col-sm-2 col-lg-2 col-form-label col-form-label-sm"></label>
        <div class="col-sm-6">
          <button @click="form.cancelar = !form.cancelar" type="button" class="btn btn-sm btn-block float-right" :class="{
            'btn-outline-danger': !form.cancelar,
            'btn-danger': form.cancelar,
          }">
            <fa-icon :icon="['far', 'circle']" v-show="!form.cancelar" />
            <fa-icon icon="times-circle" v-show="form.cancelar" /> CANCELAR
            TICKET
          </button>

          <div v-if="form.cancelar" style="margin-top: 3em">
            <div class="trix-box">
              <vue-editor :editorToolbar="customToolbarConcluir" v-model="textoCancelar"></vue-editor>
            </div>
          </div>
        </div>
      </div>

      <div v-if="_getPrivilegio(36)" class="form-group row">
        <div class="col-sm-6 offset-sm-3">
          <div class="row">
            <div class="col-5">
              <button v-if="form.cancelar" class="btn btn-danger btn-sm pull-left" @click.prevent="clickCancelar"
                :disabled="form.cancelar && textoCancelar == ''">
                <fa-icon icon="times-circle" transform="left-3" />CANCELAR
              </button>
              <template v-if="!form.id">
                <label for="file-descricao" class="btn btn-secondary">Escolher arquivos</label>
                <input class="d-none" type="file" accept="image/x-png, image/jpeg" id="file-descricao" ref="myFiles"
                  @change="previewFiles" multiple />
                <ul class="list-group list-group-flush mb-3">
                  <li class="list-group-item" v-for="({ nomeArquivo }, key) in form.files" :key="'file' - key">
                    {{ nomeArquivo }}
                  </li>
                </ul>
                <p style="margin-top: 0px; margin-bottom: 20px" class="text-info">
                  Pressione o Ctrl para adicionar mais de um item.
                </p>
              </template>
            </div>
            <div class="col-7 text-right">
              <small class="text-info" style="margin-right: 1em">
                <fa-icon icon="info-circle" transform="left-3" />Campos com *
                são obrigatórios.
              </small>
              <button class="btn btn-success btn-sm" :disabled="
                (form.cancelar && textoCancelar == '') || form.cancelar
              ">
                <fa-icon icon="check" transform="left-3" />SALVAR
              </button>
            </div>
          </div>
        </div>
      </div>

      <hr />
    </form>
    <template v-if="form.id">
      <h4>
        Interações
        <button type="button" @click="exibeCadastro = true"
          v-if="!exibeCadastro && form.status != 'O' && form.status != 'C'"
          class="btn float-right btn-sm btn-outline-primary">
          <fa-icon icon="plus" />Adicionar
        </button>
        <button type="button" @click="exibeCadastro = false" v-if="exibeCadastro"
          class="btn float-right btn-sm btn-outline-primary">
          <fa-icon icon="times" />Fechar
        </button>
      </h4>

      <div v-if="
        form.status != 'O' &&
        form.status != 'C' &&
        _getPrivilegio(36) &&
        exibeCadastro
      ">
        <div class="row">
          <div class="col-md-12 form-group">
            <div class="trix-box">
              <vue-editor :editorToolbar="customToolbar" v-model="form.descricao"></vue-editor>
            </div>
          </div>
        </div>

        <div class="form-group d-flex">
          <label for="staticEmail">Interação visivel para cliente:</label>
          <div class="col-sm-6">
            <div class="radio">
              <label class="radio-inline">
                <input id="visivelClienteInteracao" type="radio" v-model="visivelClienteInteracao" :value="true" />
                Sim </label>&nbsp;&nbsp;&nbsp;
              <label class="radio-inline">
                <input id="visivelClienteInteracao" type="radio" v-model="visivelClienteInteracao" :value="false" />
                Não
              </label>
            </div>

            <span class="invalid-feedback" v-show="errors.has('cliente')">{{
              errors.first("cliente")
            }}</span>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6">
            <input type="file" accept="image/x-png, image/jpeg" id="file" ref="myFiles" @change="previewFiles" multiple />
            <p style="margin-top: 0px; margin-bottom: 20px" class="text-info">
              Pressione o Ctrl para adicionar mais de um item.
            </p>
          </div>

          <div class="col-sm-6 text-right">
            <small class="text-info" style="margin-right: 1em">
              <fa-icon icon="info-circle" transform="left-3" />Campos com * são
              obrigatórios.
            </small>
            <button :disabled="form.descricao == ''" type="button" @click="salvaHistorico(true)"
              class="btn btn-success btn-sm">
              <fa-icon icon="check" transform="left-3" />SALVAR
            </button>
          </div>
        </div>
      </div>

      <hr />

      <div v-for="(item, index) in form.historicos" :key="item.id">
        <flTimeLine :item="item" :form="form" :index="index" />
      </div>
    </template>
  </div>
</template>

<script>
import flTimeLine from "../time-line.vue";
import _ from "lodash";
import moment from "moment";
import { mapState } from "vuex";
import axios from "../../../routers/axios";

export default {
  components: {
    flTimeLine,
  },

  data() {
    return {
      usuarios: [],
      tiposTicket: [],
      projetos: [],
      modulos: [],
      listaClientes: [],
      form: {
        id: 0,
        codigo: "",
        dataAbertura: "",
        dataEncerramento: "",
        dataPrevisao: "",
        classificacao: "",
        emailUsuario: "",
        idCliente: 0,
        desenvolvimentoConcluido: false,
        idUsuarioResponsavel: 0,
        idUsuario: 0,
        idTipoTicket: 0,
        tipoTicket: '',
        idProjeto: 0,
        modulo: "",
        loginUsuario: "",
        nomeCliente: "",
        nomeResponsavel: "",
        nomeUsuario: "",
        prioridade: "",
        status: "",
        titulo: "",
        descricao: "",
        historicos: [],
        concluir: false,
        cancelar: false,
        visivelCliente: true,
        files: [],
      },

      visivelClienteInteracao: true,

      exibeCadastro: false,
      agora: null,
      textoConclussao: "<p>Ticket concluído.</p>",
      textoCancelar: "<p>Ticket cancelado.</p>",

      customToolbar: [
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ color: [] }, { background: [] }],
        [{ align: [] }],
        ["clean"],
      ],

      customToolbarConcluir: [
        ["bold", "italic", "underline", "strike"],
        // [{ 'list': 'ordered'}, { 'list': 'bullet' }],
        // [{ 'indent': '-1'}, { 'indent': '+1' }],
        [{ color: [] }, { background: [] }],
        // [{ 'align': [] }],
        // ['clean']
      ],
    };
  },

  watch: {
    'form.tipoTicket'(newVal) {
      this.form.tipoTicket = newVal
      if (this.tiposTicket.length > 0) {
        for(let tipoTicket of this.tiposTicket)
        {
          if(tipoTicket.nome == newVal)
          this.form.idTipoTicket = tipoTicket.id
        }
      }
    }
  },

  computed: {
    __usuariosLista() {
      return _.filter(this.usuarios, (o) => {
        let existe = false;
        _.forEach(o.perfis, (p) => {
          if (p.id == this.config.idPerfilDesenvolvedor) {
            existe = true;
          }
        });

        return existe;
      });
    },

    ...mapState({
      webSocket: (state) => state.sessao.webSocket,
      sessao: (state) => state.sessao.user,
      config: (state) => state.sessao.config,
    }),
  },

  mounted() {
    this.agora = moment.utc().local();

    axios.get(this._getUrl("api/cliente")).then((response) => {
      if (response.status == 200) {
        this.clientes = response.data;
      }
    });

    axios.get(this._getUrl("api/servico")).then((response) => {
      if (response.status == 200) {
        this.servicos = response.data;
      }
    });

    axios.get(this._getUrl("api/tipoTicket")).then((response) => {
      if (response.status == 200) {
        this.tiposTicket = response.data;
      }
    });

    axios.get(this._getUrl("api/projeto")).then((response) => {
      if (response.status == 200) {
        this.projetos = response.data;
      }
    });

    axios.get(this._getUrl("api/modulo")).then((response) => {
      if (response.status == 200) {
        this.modulos = response.data;
      }
    });

    axios.get(this._getUrl("api/login")).then((result) => {
      if (result.status == 200) {
        this.usuarios = result.data;
      }
    });

    axios.get(this._getUrl("api/cliente")).then((response) => {
      if (response.status == 200) {
        this.listaClientes = response.data;
      }
    });
  },

  methods: {
    editar(item) {
      this.form.id = item.id;
      this.form.codigo = item.codigo;
      this.form.dataAbertura = item.dataAbertura;
      this.form.dataEncerramento = item.dataEncerramento;
      this.form.desenvolvimentoConcluido = item.desenvolvimentoConcluido;
      this.form.dataPrevisao =
        item.dataPrevisao == null
          ? ""
          : new moment.utc(item.dataPrevisao).local();
      this.form.classificacao = item.classificacao;
      this.form.emailUsuario = item.emailUsuario;
      this.form.idCliente = item.idCliente;
      this.form.idTipoTicket = item.idTipoTicket;
      this.form.tipoTicket = item.tipoTicket;
      this.form.idProjeto = item.idProjeto;
      this.form.modulo = item.modulo;
      this.form.idUsuarioResponsavel = item.idUsuarioResponsavel;
      this.form.idUsuario = item.idUsuario;
      this.form.loginUsuario = item.loginUsuario;
      this.form.nomeCliente = item.nomeCliente;
      this.form.nomeResponsavel = item.nomeResponsavel;
      this.form.nomeUsuario = item.nomeUsuario;
      this.form.prioridade = item.prioridade == null ? "" : item.prioridade;
      this.form.status = item.status;
      this.form.titulo = item.titulo;
      this.form.visivelCliente = item.visivelCliente;
      this.form._dataAbertura = item._dataAbertura;
      this.form._dataEncerramento = item._dataEncerramento;

      this.carregaHistorico();
    },

    previewFiles() {
      for (var i = 0; i < this.$refs.myFiles.files.length; i++) {
        this.getBase64(
          (base, index) => {
            this.form.files.push({
              base64: base,
              nomeArquivo: this.$refs.myFiles.files[index].name,
            });
          },
          this.$refs.myFiles.files[i],
          i
        );
      }
    },

    getBase64(base, file, index) {
      // console.log("file", file)
      var reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = function () {
        base(reader.result, index);
      };
      reader.onerror = function (error) {
        console.log("Error: ", error);
      };
    },

    carregaHistorico() {
      this.form.historicos = [];

      axios
        .get(this._getUrl("api/tickethistorico") + "/" + this.form.id)
        .then((retorno) => {
          this.form.historicos = retorno.data.map((item) => {
            item._data = new moment.utc(item.data)
              .local()
              .format("DD/MM/YYYY HH:mm:ss");
            return item;
          });

          this.form.historicos = _.orderBy(
            this.form.historicos,
            ["id"],
            ["desc"]
          );
        });
    },

    validateBeforeSubmit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.salva();
        }
      });
    },

    salvaHistorico(exibirNotificacao) {
      var data = {
        idTicket: this.form.id,
        idUsuarioResponsavel: this.sessao.id,
        descricao: this.form.descricao,
        anexo: this.form.files,
        visivelCliente: this.visivelClienteInteracao,
      };

      this.$notify.loadIn("Salvando");
      axios.post(this._getUrl("api/tickethistorico"), data).then((retorno) => {
        if (exibirNotificacao) {
          this.$notify.show("success", "Interação salva.");
        }
        retorno.data._data = new moment.utc(retorno.data.data)
          .local()
          .format("DD/MM/YYYY HH:mm:ss");
        this.form.historicos.unshift(retorno.data);
        this.form.descricao = "";
      });
    },

    clickDesenvolvimentoConcluido() {
      if (!this.form.desenvolvimentoConcluido) {
        this.$notify.loadIn("Concluíndo Desenvolvimento");

        axios
          .post(this._getUrl("api/ticketdesenvolvimento"), this.form.id)
          .then((response) => {
            this.form.desenvolvimentoConcluido = !this.form
              .desenvolvimentoConcluido;
            this.$emit("item-salvo", this.form);
          });
      } else {
        this.$notify.loadIn("Cancelando Desenvolvimento");

        axios
          .delete(this._getUrl("api/ticketdesenvolvimento/") + this.form.id)
          .then((response) => {
            this.form.desenvolvimentoConcluido = !this.form
              .desenvolvimentoConcluido;
            this.$emit("item-salvo", this.form);
          });
      }
    },
    clickCancelar() {
      let text = `<h4>Deseja cancelar esse ticket?</h4>
						<br>
						<p class="text-danger">
							${this.form.codigo}
							<br/><br/>ATENÇÃO!<br/>
							ESSA AÇÃO NÃO PODE SER DESFEITA
						</p>`;

      this.$modalCancelar.show(text, null, "Cancelar").then(() => {
        this.cancela();
      });
    },

    cancela() {
      this.$notify.loadIn("Cancelando");

      const data = {
        idTicket: this.form.id,
        idUsuario: this.sessao.id,
        nomeUsuario: this.sessao.nome,
        descricao: this.textoCancelar,
      };

      axios
        .delete(this._getUrl("api/ticket/") + this.form.id, { data })
        .then((response) => {
          this.editar(response.data);
          if (this.form.dataPrevisao != "") {
            this.form._dataPrevisao = new moment.utc(this.form.dataPrevisao)
              .local()
              .format("DD/MM/YYYY HH:mm");
          }
          if (response.data.dataAbertura != "") {
            this.form._dataAbertura = new moment.utc(this.form.dataAbertura)
              .local()
              .format("DD/MM/YYYY HH:mm");
          }
          this.$notify.show("success", "Ticket cancelado.");
        });
    },

    salva() {
      var data = {
        id: this.form.id,
        idCliente: this.form.idCliente,
        idTipoTicket: this.form.idTipoTicket,
        tipoTicket: this.form.tipoTicket,
        idProjeto: this.form.idProjeto,
        modulo: this.form.modulo,
        idUsuarioResponsavel: this.form.idUsuarioResponsavel,
        dataPrevisao: moment.utc(this.form.dataPrevisao),
        classificacao: this.form.classificacao,
        //        dataPrevisao: this.form.dataPrevisao,
        prioridade: this.form.prioridade,
        titulo: this.form.titulo,
        nomeUsuario: this.sessao.nome,
        idUsuario: this.sessao.id,
        emailUsuario: this.sessao.login,
        loginUsuario: this.sessao.login,
        visivelCliente: this.form.visivelCliente,
      };

      if (this.form.concluir) {
        this.$notify.loadIn("Concluindo");

        data.historico = [];

        data.historico.push({
          idTicket: this.form.id,
          idUsuarioResponsavel: this.sessao.id,
          descricao: this.textoConclussao,
          anexo: [],
        });

        axios
          .put(this._getUrl("/api/ticket") + "/" + data.id, data)
          .then((response) => {
            this.$emit("item-salvo", response.data);

            if (response.data.dataEncerramento != null) {
              response.data._dataEncerramento = new moment.utc(
                response.data.dataEncerramento
              )
                .local()
                .format("DD/MM/YYYY HH:mm");
            }

            this.form.status = response.data.status;
            this.form.dataEncerramento = response.data.dataEncerramento;
            this.form._dataEncerramento = response.data._dataEncerramento;

            this.carregaHistorico();
          });
      } else {
        this.$notify.loadIn("Salvando");

        if (this.form.descricao != "") {
          data.historico = [
            {
              descricao: this.form.descricao,
              nomeUsuario: this.sessao.nome,
              idUsuario: this.sessao.id,
              anexo: this.form.files,
            },
          ];
          data.idUsuarioResponsavel = this.sessao.id;
        }

        axios.post(this._getUrl("api/ticket"), data).then((response) => {
          this.$emit("item-salvo", response.data);

          this.form.status = response.data.status;

          this.editar(response.data);
          if (this.form.dataPrevisao != "") {
            this.form._dataPrevisao = new moment.utc(this.form.dataPrevisao)
              .local()
              .format("DD/MM/YYYY HH:mm");
          }
          if (response.data.dataAbertura != "") {
            this.form._dataAbertura = new moment.utc(this.form.dataAbertura)
              .local()
              .format("DD/MM/YYYY HH:mm");
          }
          if (response.data.idUsuarioResponsavel != 0) {
            if (this.usuarios.length > 0) {
              this.form.nomeResponsavel = _.find(this.usuarios, (o) => {
                return response.data.idUsuarioResponsavel == o.id;
              }).nome;
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.trix-box {
  background: #fff;
}
</style>



// WEBPACK FOOTER //
// src/views/ticket/geral/cadastro.vue